import { usePageContext } from 'application/contexts/PageContext';
import { findFaqItems } from 'helpers/jsonLd';
import { JsonLdScript } from './JsonLdScript';

// Only fires where an editor explicitly flagged an accordion as genuine FAQ content (isFaq).
export const FaqJsonLd: React.FC = () => {
	const pageContext = usePageContext();

	const mainEntity = findFaqItems(pageContext?.content?.pageSections);
	if (!mainEntity.length) return null;

	const data = {
		'@context': 'https://schema.org',
		'@type': 'FAQPage',
		mainEntity,
	};

	return <JsonLdScript id="faq-jsonld" data={data} />;
};
